export const sellerHarnessTranslations = {
  pt: {
    'meta.title': 'LOYOL Seller — A inteligência operacional do seu negócio, em todos os canais.',
    'meta.description': 'O Seller aprende como sua empresa vende e transforma dados, regras e processos em uma operação digital que funciona em todos os canais.',
    'a11y.skip': 'Pular para o conteúdo',
    'a11y.nav': 'Principal',
    'cta.talk': 'Quero conversar',
    'cta.primary': 'Transformar minha operação',
    'cta.secondary': 'Ver como funciona',
    'hero.eyebrow': 'OPERAÇÃO DIGITAL GERENCIADA',
    'hero.title': 'Seu negócio já sabe vender.<br><span>O Seller transforma esse conhecimento em sistema.</span>',
    'hero.description': 'Aprendemos seu catálogo, seus clientes e o jeito certo de vender, atender e entregar. Depois operamos site, WhatsApp e marketplaces como uma única força de vendas — do pedido ao pós-venda.',
    'hero.note': 'Sem mensalidade. A Loyol só ganha quando gera venda.',
    'map.aria': 'O Seller conecta canais de venda à inteligência operacional da empresa e usa inteligência artificial como motor substituível',
    'map.channels': 'ONDE SEU CLIENTE COMPRA',
    'map.site': 'Loja online',
    'map.marketplaces': 'Marketplaces',
    'map.core': 'A inteligência do seu negócio',
    'map.active': 'ATIVA',
    'map.data': 'Dados',
    'map.dataDesc': 'clientes, catálogo, pedidos',
    'map.workflows': 'Fluxos',
    'map.workflowsDesc': 'venda, entrega, pós-venda',
    'map.rules': 'Regras',
    'map.rulesDesc': 'margem, estoque, regiões',
    'map.quality': 'Qualidade',
    'map.qualityDesc': 'confere antes de agir',
    'map.engine': 'MOTOR DE IA',
    'map.engineDesc': 'A melhor tecnologia para cada tarefa',
    'map.foot': 'A tecnologia evolui. O conhecimento do seu negócio fica.',
    'proof.aria': 'Resumo do serviço',
    'proof.oneTitle': 'Aprende seu jeito',
    'proof.oneText': 'Não força sua empresa a caber num software.',
    'proof.twoTitle': 'Opera os canais',
    'proof.twoText': 'Não entrega mais uma ferramenta para você cuidar.',
    'proof.threeTitle': 'Melhora com cada venda',
    'proof.threeText': 'Cada pedido vira contexto para o próximo.',
    'problem.kicker': 'O PROBLEMA NÃO É FALTA DE SOFTWARE',
    'problem.title': 'Seu negócio está espalhado em ferramentas que <span>não conversam entre si.</span>',
    'problem.description': 'O site recebe o pedido. O WhatsApp responde. A planilha conhece o estoque. Uma pessoa sabe a exceção. E você continua sendo a única integração entre tudo.',
    'problem.card1Title': 'Uma loja online',
    'problem.card1Text': 'vende, mas não conhece a operação por trás da tela.',
    'problem.card2Title': 'Um chatbot',
    'problem.card2Text': 'responde, mas não sabe o que pode prometer ou executar.',
    'problem.card3Title': 'Mais integrações',
    'problem.card3Text': 'movem dados, mas deixam as decisões com você.',
    'problem.answer': 'O Seller é a camada que entende <strong>como o seu negócio funciona</strong> e faz essas ferramentas operarem como uma única empresa.',
    'system.kicker': 'O QUE FICA NO CENTRO',
    'system.title': 'A inteligência que faz sua empresa ser <span>sua.</span>',
    'system.description': 'Não treinamos você para usar uma plataforma genérica. Nós transformamos seu contexto real em uma operação repetível.',
    'system.dataTitle': 'Seus dados',
    'system.dataText': 'Clientes, catálogo, pedidos, recompra, estoque e desempenho de cada canal.',
    'system.dataExample': 'O que aconteceu',
    'system.flowTitle': 'Seus fluxos',
    'system.flowText': 'Como vender, cobrar, separar, entregar, atender uma exceção e trazer o cliente de volta.',
    'system.flowExample': 'Como o trabalho acontece',
    'system.rulesTitle': 'Suas regras',
    'system.rulesText': 'Margem mínima, regiões, horários, capacidade, descontos e quando chamar uma pessoa.',
    'system.rulesExample': 'O que pode e não pode',
    'system.qualityTitle': 'Seus critérios',
    'system.qualityText': 'Verificações que impedem preço errado, promessa impossível ou entrega fora do padrão.',
    'system.qualityExample': 'O que significa fazer bem',
    'example.kicker': 'DO PEDIDO À ENTREGA',
    'example.title': 'Não é uma resposta bonita.<br><span>É trabalho concluído.</span>',
    'example.description': 'Quando um cliente pede uma cotação no WhatsApp, o Seller não começa do zero. Ele combina o pedido com o contexto da empresa, verifica os limites e conduz a operação.',
    'example.check1': 'Confere produto, estoque e histórico do cliente',
    'example.check2': 'Aplica preço, margem, quantidade mínima e região',
    'example.check3': 'Gera cobrança e coordena separação e entrega',
    'example.check4': 'Escala para uma pessoa quando algo sai da regra',
    'example.check5': 'Registra o resultado para a próxima venda',
    'example.panelLabel': 'PEDIDO #1842 · WHATSAPP',
    'example.customer': 'CLIENTE',
    'example.message': 'Vocês entregam 4 caixas de congelados amanhã na Vila Mariana?',
    'example.stock': 'ESTOQUE',
    'example.stockValue': 'disponível',
    'example.margin': 'MARGEM',
    'example.marginValue': 'aprovada',
    'example.route': 'ROTA',
    'example.routeValue': 'válida',
    'example.reply': 'Sim. Separei os itens, calculei o valor correto e reservei a janela de entrega. Posso gerar o PIX?',
    'example.status': 'Regras verificadas antes da resposta',
    'compound.kicker': 'O ATIVO QUE SE ACUMULA',
    'compound.title': 'A IA pode mudar.<br><span>O aprendizado fica.</span>',
    'compound.description': 'Modelos de inteligência artificial ficam mais rápidos e baratos. O que diferencia sua empresa não é o modelo: é o contexto construído em cada atendimento, pedido, exceção e resultado.',
    'compound.highlight': 'Com o Seller, esse conhecimento deixa de ficar espalhado na cabeça das pessoas e passa a trabalhar para a empresa inteira.',
    'offer.kicker': 'INTERESSES ALINHADOS',
    'offer.title': 'Você não compra software.<br><span>Você ganha uma operação.</span>',
    'offer.description': 'Nós configuramos, conectamos e operamos o canal digital. Você continua cuidando do produto e dos clientes. O Seller cuida do trabalho entre a intenção de compra e a venda concluída.',
    'offer.tag1': 'Implantação gerenciada',
    'offer.tag2': 'Operação contínua',
    'offer.tag3': 'Sem mensalidade',
    'offer.priceLabel': 'MENSALIDADE',
    'offer.currency': 'R$',
    'offer.priceText': 'Comissão somente sobre as vendas que o canal gera.',
    'final.kicker': 'LOYOL SELLER',
    'final.title': 'Transforme o jeito que sua empresa vende<br><span>em uma operação que trabalha todos os dias.</span>',
    'final.description': 'Conte como seu negócio funciona. A gente mostra o que já pode ser automatizado, conectado e vendido.',
    'final.cta': 'Conversar sobre meu negócio',
    'footerHarness.statement': 'A inteligência operacional do seu negócio, trabalhando em todos os canais.',
    'footerHarness.navAria': 'Navegação da página',
    'footerHarness.navigation': 'NAVEGUE',
    'footerHarness.how': 'Como funciona',
    'footerHarness.example': 'Exemplo real',
    'footerHarness.offer': 'Modelo comercial',
    'footerHarness.contact': 'CONVERSE COM A GENTE',
    'footerHarness.language': 'Idioma',
  },

  en: {
    'meta.title': 'LOYOL Seller — Your business intelligence, working across every channel.',
    'meta.description': 'Seller learns how your business sells and turns its data, rules and processes into a digital operation that works across every channel.',
    'a11y.skip': 'Skip to content',
    'a11y.nav': 'Main navigation',
    'cta.talk': 'Let\'s talk',
    'cta.primary': 'Transform my operation',
    'cta.secondary': 'See how it works',
    'hero.eyebrow': 'FULLY MANAGED DIGITAL OPERATIONS',
    'hero.title': 'Your business already knows how to sell.<br><span>Seller turns that knowledge into a system.</span>',
    'hero.description': 'We learn your catalogue, your customers and the right way to sell, support and deliver. Then we run your website, WhatsApp and marketplaces as one sales operation — from order to after-sales.',
    'hero.note': 'No monthly fee. Loyol only earns when it generates a sale.',
    'map.aria': 'Seller connects sales channels to the company\'s operational intelligence and uses artificial intelligence as a replaceable engine',
    'map.channels': 'WHERE YOUR CUSTOMER BUYS',
    'map.site': 'Online shop',
    'map.marketplaces': 'Marketplaces',
    'map.core': 'Your business intelligence',
    'map.active': 'LIVE',
    'map.data': 'Data',
    'map.dataDesc': 'customers, catalogue, orders',
    'map.workflows': 'Workflows',
    'map.workflowsDesc': 'sales, delivery, after-sales',
    'map.rules': 'Rules',
    'map.rulesDesc': 'margin, stock, delivery areas',
    'map.quality': 'Quality',
    'map.qualityDesc': 'checks before it acts',
    'map.engine': 'AI ENGINE',
    'map.engineDesc': 'The best technology for each task',
    'map.foot': 'Technology evolves. Your business knowledge stays.',
    'proof.aria': 'Service summary',
    'proof.oneTitle': 'Learns your way',
    'proof.oneText': 'It does not force your business to fit the software.',
    'proof.twoTitle': 'Runs the channels',
    'proof.twoText': 'It does not hand you yet another tool to manage.',
    'proof.threeTitle': 'Improves with every sale',
    'proof.threeText': 'Every order becomes context for the next.',
    'problem.kicker': 'THE PROBLEM IS NOT A LACK OF SOFTWARE',
    'problem.title': 'Your business is scattered across tools that <span>do not talk to each other.</span>',
    'problem.description': 'The website takes the order. WhatsApp replies. A spreadsheet knows the stock. One person knows the exception. And you are still the only integration between it all.',
    'problem.card1Title': 'An online shop',
    'problem.card1Text': 'sells, but does not understand the operation behind the screen.',
    'problem.card2Title': 'A chatbot',
    'problem.card2Text': 'replies, but does not know what it can promise or execute.',
    'problem.card3Title': 'More integrations',
    'problem.card3Text': 'move data around, but leave the decisions to you.',
    'problem.answer': 'Seller is the layer that understands <strong>how your business works</strong> and makes those tools operate as one company.',
    'system.kicker': 'WHAT STAYS AT THE CENTRE',
    'system.title': 'The intelligence that makes your business <span>yours.</span>',
    'system.description': 'We do not train you to use a generic platform. We turn your real-world context into a repeatable operation.',
    'system.dataTitle': 'Your data',
    'system.dataText': 'Customers, catalogue, orders, repeat purchases, stock and channel performance.',
    'system.dataExample': 'What happened',
    'system.flowTitle': 'Your workflows',
    'system.flowText': 'How to sell, charge, pick, deliver, handle an exception and bring the customer back.',
    'system.flowExample': 'How work gets done',
    'system.rulesTitle': 'Your rules',
    'system.rulesText': 'Minimum margin, areas, hours, capacity, discounts and when to call a person.',
    'system.rulesExample': 'What is and is not allowed',
    'system.qualityTitle': 'Your standards',
    'system.qualityText': 'Checks that prevent wrong prices, impossible promises or substandard delivery.',
    'system.qualityExample': 'What good looks like',
    'example.kicker': 'FROM ORDER TO DELIVERY',
    'example.title': 'It is not a polished reply.<br><span>It is work completed.</span>',
    'example.description': 'When a customer asks for a quote on WhatsApp, Seller does not start from scratch. It combines the request with the company context, checks the boundaries and runs the operation.',
    'example.check1': 'Checks product, stock and customer history',
    'example.check2': 'Applies price, margin, minimum quantity and delivery area',
    'example.check3': 'Creates payment and coordinates picking and delivery',
    'example.check4': 'Escalates to a person when something falls outside the rules',
    'example.check5': 'Records the outcome for the next sale',
    'example.panelLabel': 'ORDER #1842 · WHATSAPP',
    'example.customer': 'CUSTOMER',
    'example.message': 'Can you deliver 4 boxes of frozen food to Camden tomorrow?',
    'example.stock': 'STOCK',
    'example.stockValue': 'available',
    'example.margin': 'MARGIN',
    'example.marginValue': 'approved',
    'example.route': 'ROUTE',
    'example.routeValue': 'valid',
    'example.reply': 'Yes. I have set the items aside, calculated the correct total and reserved the delivery slot. Shall I create the payment link?',
    'example.status': 'Rules checked before replying',
    'compound.kicker': 'THE ASSET THAT COMPOUNDS',
    'compound.title': 'AI can change.<br><span>The learning stays.</span>',
    'compound.description': 'Artificial intelligence models keep getting faster and cheaper. What makes your company different is not the model: it is the context built through every conversation, order, exception and outcome.',
    'compound.highlight': 'With Seller, that knowledge stops being scattered across people\'s heads and starts working for the whole company.',
    'offer.kicker': 'ALIGNED INCENTIVES',
    'offer.title': 'You are not buying software.<br><span>You are gaining an operation.</span>',
    'offer.description': 'We configure, connect and run the digital channel. You keep looking after the product and customers. Seller handles the work between purchase intent and a completed sale.',
    'offer.tag1': 'Managed setup',
    'offer.tag2': 'Continuous operation',
    'offer.tag3': 'No monthly fee',
    'offer.priceLabel': 'MONTHLY FEE',
    'offer.currency': '£',
    'offer.priceText': 'Commission only on sales generated by the channel.',
    'final.kicker': 'LOYOL SELLER',
    'final.title': 'Turn the way your business sells<br><span>into an operation that works every day.</span>',
    'final.description': 'Tell us how your business works. We will show you what can already be automated, connected and sold.',
    'final.cta': 'Talk about my business',
    'footerHarness.statement': 'Your operational intelligence, working across every sales channel.',
    'footerHarness.navAria': 'Page navigation',
    'footerHarness.navigation': 'EXPLORE',
    'footerHarness.how': 'How it works',
    'footerHarness.example': 'Real example',
    'footerHarness.offer': 'Commercial model',
    'footerHarness.contact': 'TALK TO US',
    'footerHarness.language': 'Language',
  },

  it: {
    'meta.title': 'LOYOL Seller — L\'intelligenza operativa della tua attività, su ogni canale.',
    'meta.description': 'Seller impara come vende la tua attività e trasforma dati, regole e processi in un\'operazione digitale attiva su ogni canale.',
    'a11y.skip': 'Vai al contenuto',
    'a11y.nav': 'Navigazione principale',
    'cta.talk': 'Parliamone',
    'cta.primary': 'Trasformare la mia attività',
    'cta.secondary': 'Scopri come funziona',
    'hero.eyebrow': 'OPERAZIONE DIGITALE GESTITA',
    'hero.title': 'La tua attività sa già vendere.<br><span>Seller trasforma questa conoscenza in un sistema.</span>',
    'hero.description': 'Impariamo il tuo catalogo, i tuoi clienti e il modo giusto di vendere, assistere e consegnare. Poi gestiamo sito, WhatsApp e marketplace come un\'unica forza vendita, dall\'ordine al post-vendita.',
    'hero.note': 'Nessun canone mensile. Loyol guadagna solo quando genera una vendita.',
    'map.aria': 'Seller collega i canali di vendita all\'intelligenza operativa dell\'azienda e usa l\'intelligenza artificiale come motore sostituibile',
    'map.channels': 'DOVE ACQUISTA IL CLIENTE',
    'map.site': 'Negozio online',
    'map.marketplaces': 'Marketplace',
    'map.core': 'L\'intelligenza della tua attività',
    'map.active': 'ATTIVA',
    'map.data': 'Dati',
    'map.dataDesc': 'clienti, catalogo, ordini',
    'map.workflows': 'Flussi',
    'map.workflowsDesc': 'vendita, consegna, post-vendita',
    'map.rules': 'Regole',
    'map.rulesDesc': 'margine, scorte, zone',
    'map.quality': 'Qualità',
    'map.qualityDesc': 'controlla prima di agire',
    'map.engine': 'MOTORE IA',
    'map.engineDesc': 'La tecnologia migliore per ogni attività',
    'map.foot': 'La tecnologia evolve. La conoscenza della tua attività resta.',
    'proof.aria': 'Sintesi del servizio',
    'proof.oneTitle': 'Impara il tuo metodo',
    'proof.oneText': 'Non costringe la tua attività ad adattarsi al software.',
    'proof.twoTitle': 'Gestisce i canali',
    'proof.twoText': 'Non ti consegna l\'ennesimo strumento da amministrare.',
    'proof.threeTitle': 'Migliora a ogni vendita',
    'proof.threeText': 'Ogni ordine diventa contesto per il successivo.',
    'problem.kicker': 'IL PROBLEMA NON È LA MANCANZA DI SOFTWARE',
    'problem.title': 'La tua attività è sparsa tra strumenti che <span>non comunicano tra loro.</span>',
    'problem.description': 'Il sito riceve l\'ordine. WhatsApp risponde. Un foglio conosce le scorte. Una persona sa gestire l\'eccezione. E tu resti l\'unica integrazione tra tutto.',
    'problem.card1Title': 'Un negozio online',
    'problem.card1Text': 'vende, ma non conosce l\'operazione dietro lo schermo.',
    'problem.card2Title': 'Un chatbot',
    'problem.card2Text': 'risponde, ma non sa cosa può promettere o eseguire.',
    'problem.card3Title': 'Altre integrazioni',
    'problem.card3Text': 'spostano i dati, ma lasciano a te le decisioni.',
    'problem.answer': 'Seller è il livello che capisce <strong>come funziona la tua attività</strong> e fa operare questi strumenti come un\'unica azienda.',
    'system.kicker': 'COSA RESTA AL CENTRO',
    'system.title': 'L\'intelligenza che rende la tua attività <span>davvero tua.</span>',
    'system.description': 'Non ti addestriamo a usare una piattaforma generica. Trasformiamo il tuo contesto reale in un\'operazione ripetibile.',
    'system.dataTitle': 'I tuoi dati',
    'system.dataText': 'Clienti, catalogo, ordini, riacquisti, scorte e rendimento di ogni canale.',
    'system.dataExample': 'Cosa è successo',
    'system.flowTitle': 'I tuoi flussi',
    'system.flowText': 'Come vendere, incassare, preparare, consegnare, gestire un\'eccezione e far tornare il cliente.',
    'system.flowExample': 'Come viene svolto il lavoro',
    'system.rulesTitle': 'Le tue regole',
    'system.rulesText': 'Margine minimo, zone, orari, capacità, sconti e quando coinvolgere una persona.',
    'system.rulesExample': 'Cosa si può e non si può fare',
    'system.qualityTitle': 'I tuoi criteri',
    'system.qualityText': 'Controlli che evitano prezzi errati, promesse impossibili o consegne fuori standard.',
    'system.qualityExample': 'Cosa significa lavorare bene',
    'example.kicker': 'DALL\'ORDINE ALLA CONSEGNA',
    'example.title': 'Non è una bella risposta.<br><span>È lavoro completato.</span>',
    'example.description': 'Quando un cliente chiede un preventivo su WhatsApp, Seller non parte da zero. Combina la richiesta con il contesto aziendale, verifica i limiti e gestisce l\'operazione.',
    'example.check1': 'Controlla prodotto, scorte e storico del cliente',
    'example.check2': 'Applica prezzo, margine, quantità minima e zona',
    'example.check3': 'Genera il pagamento e coordina preparazione e consegna',
    'example.check4': 'Coinvolge una persona quando qualcosa esce dalle regole',
    'example.check5': 'Registra il risultato per la prossima vendita',
    'example.panelLabel': 'ORDINE #1842 · WHATSAPP',
    'example.customer': 'CLIENTE',
    'example.message': 'Consegnate 4 scatole di surgelati domani ai Navigli?',
    'example.stock': 'SCORTE',
    'example.stockValue': 'disponibili',
    'example.margin': 'MARGINE',
    'example.marginValue': 'approvato',
    'example.route': 'PERCORSO',
    'example.routeValue': 'valido',
    'example.reply': 'Sì. Ho riservato i prodotti, calcolato il totale corretto e bloccato la fascia di consegna. Posso generare il link di pagamento?',
    'example.status': 'Regole verificate prima della risposta',
    'compound.kicker': 'L\'ASSET CHE CRESCE',
    'compound.title': 'L\'IA può cambiare.<br><span>Ciò che ha imparato resta.</span>',
    'compound.description': 'I modelli di intelligenza artificiale diventano più veloci ed economici. A distinguere la tua azienda non è il modello: è il contesto costruito in ogni conversazione, ordine, eccezione e risultato.',
    'compound.highlight': 'Con Seller, questa conoscenza smette di essere sparsa nella testa delle persone e comincia a lavorare per tutta l\'azienda.',
    'offer.kicker': 'INTERESSI ALLINEATI',
    'offer.title': 'Non compri un software.<br><span>Ottieni un\'operazione.</span>',
    'offer.description': 'Configuriamo, colleghiamo e gestiamo il canale digitale. Tu continui a occuparti del prodotto e dei clienti. Seller cura il lavoro tra l\'intenzione di acquisto e la vendita conclusa.',
    'offer.tag1': 'Avvio gestito',
    'offer.tag2': 'Operazione continua',
    'offer.tag3': 'Nessun canone mensile',
    'offer.priceLabel': 'CANONE MENSILE',
    'offer.currency': '€',
    'offer.priceText': 'Commissione solo sulle vendite generate dal canale.',
    'final.kicker': 'LOYOL SELLER',
    'final.title': 'Trasforma il modo in cui la tua azienda vende<br><span>in un\'operazione che lavora ogni giorno.</span>',
    'final.description': 'Raccontaci come funziona la tua attività. Ti mostreremo cosa si può già automatizzare, collegare e vendere.',
    'final.cta': 'Parlare della mia attività',
    'footerHarness.statement': 'L\'intelligenza operativa della tua attività, al lavoro su ogni canale.',
    'footerHarness.navAria': 'Navigazione della pagina',
    'footerHarness.navigation': 'ESPLORA',
    'footerHarness.how': 'Come funziona',
    'footerHarness.example': 'Esempio reale',
    'footerHarness.offer': 'Modello commerciale',
    'footerHarness.contact': 'PARLA CON NOI',
    'footerHarness.language': 'Lingua',
  },
};
